import {LegacySponsorAdaptor} from './legacySponsorAdaptor.js';
import {LegacyTermsAndConditionsAdaptor} from './legacyTermsAndConditionsAdaptor.js';
import {LegacyBankInfoAdaptor} from './legacyBankInfoAdaptor.js';
import {LegacyCommPreferencesAdaptor} from './legacyCommPreferencesAdaptor.js';
import {LegacyContactInfoAdaptor} from './legacyContactInfoAdaptor.js';
import {LegacyPrivacyOptionInfoAdaptor} from './legacyPrivacyOptionInfoAdaptor.js';
import {LegacyAccountPersonAdaptor} from './legacyAccountPersonAdaptor.js';

// The purpose of this object is use the new Account service call and associated models and create the structure that
// is produced by the legacy Account call. At some later date we may want to remove
// all the legacy structure dependencies
// and use just the new structure.
export var LegacyAccountAdaptor = function(accountData, sponsor) {
    var account = {};

    // Constructor
    if (accountData) {
        var primaryPerson = accountData.getPrimaryPerson();

        // Map the old account service structure to the new account service structure. Btw, the new account structure
        // can be obtained from the new account models.
        account.header = {
            accountType: accountData.accountType,
            beType: accountData.beType,
            accountID: accountData.id,
            temporary: accountData.temporary,
            termsAndConditions: primaryPerson.termsAndConditions,
            taxIDs: primaryPerson.legalIDs,
            businessName: primaryPerson.names.getAName().getFormattedName(),
            sponsor: undefined,
            profileImageUrl: primaryPerson.profilePictureUrl,
            ProfileThumbnailUrl: primaryPerson.profileThumbnailUrl,
            termsAndConditions: LegacyTermsAndConditionsAdaptor(primaryPerson.termsAndConditions)
        };

        if (sponsor) {
            account.header.sponsor = LegacySponsorAdaptor(sponsor);
        }

        account.address = primaryPerson.addresses.getAnAddress();
        // todo We need to know what what the new service returns so we can map account.
        // The new service RAML doesn't have and example.
        account.bankInfo = LegacyBankInfoAdaptor(null);

        account.commPreferences = LegacyCommPreferencesAdaptor(primaryPerson);

        account.contactInfo = LegacyContactInfoAdaptor(primaryPerson);

        account.privacyOptionInfo = LegacyPrivacyOptionInfoAdaptor(primaryPerson.preferences);

        account.persons = [];
        for (var i=0; i<accountData.persons.length; i++) {
            account.persons.push(LegacyAccountPersonAdaptor(accountData.persons[i]));
        }
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return account;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyAccountAdaptor.js
// module id = 360
// module chunks = 0